import {
  CHANGE_SUBJECT_VALUES,
  CLEAR_CURRENT_CASE_DETAILS,
  CLEAR_EXAME_METHODS,
  RESET_ALL_CASE_REGISTERATION_FORM,
  RESET_CURRENT_COMPLETED_TOOTH,
  SELECT_CONDITION_FOR_TOOTH_FOR_EXAM,
  SELECT_TEMP_TOOTH_FOR_EXAM,
  SET_CURRENT_CASE_DETAILS,
  SET_EXAME_METHODS,
} from "../../actions/age-assessment/caseRegistrationAction";

export const initialState = {
  teethChart: [
    {
      id: 1, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 18,
    },
    {
      id: 2, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 17,
    },
    {
      id: 3, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 16,
    },
    {
      id: 4, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 15,
    },
    {
      id: 5, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 14,
    },
    {
      id: 6, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 13,
    },
    {
      id: 7, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 12,
    },
    {
      id: 8, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 11,
    },

    {
      id: 9, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 21,
    },
    {
      id: 10, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 22,
    },
    {
      id: 11, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 23,
    },
    {
      id: 12, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 24,
    },
    {
      id: 13, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 25,
    },
    {
      id: 14, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 26,
    },
    {
      id: 15, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 27,
    },
    {
      id: 16, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 28,
    },
    {
      id: 17, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 38,
    },
    {
      id: 18, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 37,
    },
    {
      id: 19, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 36,
    },
    {
      id: 20, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 35,
    },
    {
      id: 21, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 34,
    },
    {
      id: 22, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 33,
    },
    {
      id: 23, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 32,
    },
    {
      id: 24, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 31,
    },
    {
      id: 25, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 41,
    },
    {
      id: 26, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 42,
    },
    {
      id: 27, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 43,
    },
    {
      id: 28, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 44,
    },
    {
      id: 29, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 45,
    },
    {
      id: 30, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 46,
    },
    {
      id: 31, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition_identifier: "",
      condition_type: "",
      marked_completed: false,
      iso: 47,
    },
    {
      id: 32, // Unique ID for each tooth
      tooth_id: "", // Tooth ID (1-32)
      condition: "",
      marked_completed: false,
      iso: 48,
    },
  ],
  subject: {
    full_name: "",
    identity_type: "",
    identity_number: "",
    nationality: "",
    status: "",
    reported_dob: "",
    age_years: "",
    ethnicity: "",
    referring_agency: "",
    gender: "",
    medical_history: "",
    height: "",
    weight: "",
    purpose_of_assessment: "",
    bone_assessment: "",
    radiograph_date: new Date(),
    dental_observation: "",
  },
  tempTeeth: [],
  exameMethods: [],
  currentCaseDetail: null,
};

export default function caseRegistratiojnReducer(state = initialState, action) {
  switch (action.type) {
    case SELECT_TEMP_TOOTH_FOR_EXAM:
      const id = action.payload;
      const isAlreadySelected = state.tempTeeth.includes(id);

      return {
        ...state,
        tempTeeth: isAlreadySelected
          ? state.tempTeeth.filter((tooth) => tooth !== id) // Remove if exists
          : [...state.tempTeeth, id], // Add if not exists
      };

      break;
    case SELECT_CONDITION_FOR_TOOTH_FOR_EXAM:
      const condition = action.payload; // Selected condition object

      return {
        ...state,
        teethChart: state.teethChart.map((tooth) =>
          state.tempTeeth.includes(tooth.id)
            ? {
                ...tooth,
                tooth_id: tooth.id,
                condition_identifier: condition.identifier,
                condition_type: condition.type,
                marked_completed: true,
              }
            : tooth
        ),
        tempTeeth: [],
      };
      break;
    case CHANGE_SUBJECT_VALUES:
      return {
        ...state,
        subject: {
          ...state.subject,
          [action.payload.field]: action.payload.value,
        },
      };
      break;
    case RESET_ALL_CASE_REGISTERATION_FORM:
      return {
        ...initialState,
        currentCaseDetail: state.currentCaseDetail, // preserve this
      };
    case SET_EXAME_METHODS:
      return {
        ...state,
        exameMethods: action.payload,
      };
      break;
    case CLEAR_EXAME_METHODS:
      return {
        ...state,
        exameMethods: [],
      };
      break;
    case SET_CURRENT_CASE_DETAILS:
      return {
        ...state,
        currentCaseDetail: action.payload,
      };
      break;
    case CLEAR_CURRENT_CASE_DETAILS:
      return {
        ...state,
        currentCaseDetail: null,
      };
      break;

    case RESET_CURRENT_COMPLETED_TOOTH:
      return {
        ...state,
        teethChart: state.teethChart.map((tooth) =>
          state.tempTeeth.includes(tooth.id)
            ? {
                ...tooth,
                tooth_id: "",
                condition_identifier: "",
                condition_type: "",
                marked_completed: false,
              }
            : tooth
        ),
        tempTeeth: [],
      };

    default:
      return state;
      break;
  }
}
